/* MAMA-HIDDENFOCUS (08/10/2026, Lighthouse accessibilité + navigation IA) : dans les carrousels Horizon, les cartes hors écran sont marquées
   « cachées » (aria-hidden) mais leurs liens restaient atteignables au clavier → on les sort de la touche Tab (tabindex=-1) tant qu'elles sont cachées,
   et on rend leur état d'origine dès qu'elles réapparaissent. Les clics ne changent pas (pas d'« inert »). */
(function(){
  if (window.__mamaHiddenFocus) return; window.__mamaHiddenFocus = 1;
  var SEL = 'a[href],button,input,select,textarea,[tabindex]';
  function sync(sl){
    var hide = sl.getAttribute('aria-hidden') === 'true';
    sl.querySelectorAll(SEL).forEach(function(el){
      if (hide) {
        if (!el.hasAttribute('data-mama-ti')) { el.setAttribute('data-mama-ti', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '-'); el.setAttribute('tabindex', '-1'); }
      } else if (el.hasAttribute('data-mama-ti')) {
        var v = el.getAttribute('data-mama-ti'); el.removeAttribute('data-mama-ti');
        if (v === '-') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', v);
      }
    });
  }
  function all(){ document.querySelectorAll('slideshow-slide[aria-hidden],slideshow-slide[data-mama-seen]').forEach(function(sl){ sl.setAttribute('data-mama-seen',''); sync(sl); }); }
  var t; function later(){ clearTimeout(t); t = setTimeout(all, 150); }
  new MutationObserver(function(ms){
    for (var i = 0; i < ms.length; i++) {
      var m = ms[i];
      if (m.type === 'attributes') { if (m.target.tagName === 'SLIDESHOW-SLIDE') { m.target.setAttribute('data-mama-seen',''); sync(m.target); } }
      else if (m.addedNodes.length) { later(); }
    }
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
})();
